import { FC } from "react";
import { SubcategoryType } from "data/types";
// import { ArrowRightIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
// import Avatar from "shared/Avatar/Avatar";
import NcImage from "shared/NcImage/NcImage";
import convertNumbThousand from "utils/convertNumbThousand";

export interface CardSubcategoryBoxProps {
  className?: string;
  subcategory: SubcategoryType;
}

const CardSubcategoryBox: FC<CardSubcategoryBoxProps> = ({
  className = "",
  subcategory,
}) => {
  const { id, description, image_url, name, product_count } = subcategory;
  return (
    <Link
      to={`/products/${id}`}
      className={`nc-CardAuthorBox2 flex flex-col overflow-hidden bg-white dark:bg-neutral-900 rounded-3xl hover:shadow-xl transition-shadow`}
      data-nc-id="CardAuthorBox2"
    >
      <div className="relative flex-shrink-0 ">
        <div>
          <NcImage
            containerClassName="flex aspect-w-7 aspect-h-3 md:aspect-h-4 w-full h-0"
            src={image_url}
          />
        </div>
        <div className="absolute top-3 inset-x-3 flex">
          <div className="py-1 px-4 bg-neutral-100 dark:bg-neutral-800 rounded-full flex items-center justify-center leading-none text-xs font-medium">
            {convertNumbThousand(product_count)}{" "}
            {/* <ArrowRightIcon className="w-5 h-5 text-yellow-600 ml-3" /> */}
          </div>
        </div>
      </div>
      <div className="pt-[1px] p-6 text-center flex flex-col items-center relative">
        {/* <span className="absolute top-2">
          <Avatar
            containerClassName=""
            sizeClass="w-12 h-12 text-2xl"
            radius="rounded-full"
            imgUrl={image_url}
            userName={name}
          />
        </span> */}
        <div className="mt-6 w-[20rem]  ">
          <h1 className={`text-base font-medium`}>
            <span className="line-clamp-1">{name}</span>
          </h1>
          <span
            className={`block mt-1 text-sm text-neutral-500 dark:text-neutral-400`}
          >
            {description}
          </span>
        </div>
      </div>
    </Link>
  );
};

export default CardSubcategoryBox;
